import { Vue, Prop, Component } from 'vue-property-decorator';
import { FormElementData, FormElement } from '@/models/FormElement';
import { Form } from '@/models/Form';
import { mapGetters } from 'vuex';

@Component({
    name: 'ElementBase',
    computed: mapGetters({
        formElementTags: 'formElementTags/all',
    }),
})
export default class ElementBase extends Vue {
    updating: boolean = false;

    @Prop() element!: FormElement;
    @Prop() form!: Form;

    get input(): FormElementData {
        return this.element.params || new FormElementData({});
    }

    set input(data: FormElementData) {
        this.element.params = data;
    }
}
